// Landing page is served as static HTML in public/index.html
// React app renders nothing — kept only for CRA build compatibility
function App() {
  return null;
}

export default App;
